import { API_ROUTES } from "../constants/api_routes";
import { API_LOG_MESSAGES } from "../constants/api_log_messages";
import { API_REQUESTS } from "../constants/types";

export const runAPIRequest = async ({ request, params, options }) => {
  var route = API_ROUTES[request];

  if (params) {
    for (const [key, value] of Object.entries(params)) {
      route = route.replace(`:${key}`, value);
    }
  }

  const requestOptions = options
    ? {
        method: options.method ?? "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: options.body ?? {},
      }
    : {};

  const response = await fetch("/api/v1/" + route, requestOptions);
  const data = await response.json();
  return { data: data, statusCode: response.status };
};

export const checkIfCredentialsValid = async (parameters, password) => {
  return runAPIRequest({
    request: API_REQUESTS.CHECK_IF_CREDENTIALS_VALID,
    options: {
      method: "POST",
      body: JSON.stringify({
        ...parameters,
        password: password,
      }),
    },
  }).then((response) => {
    console.log(API_LOG_MESSAGES.CHECK_IF_CREDENTIALS_VALID[response.statusCode]);
    return response.data;
  });
};

export const checkIfSurveyLinkedToApplicantGroup = async (parameters) => {
  return runAPIRequest({
    request: API_REQUESTS.CHECK_IF_SURVEY_LINKED_TO_APPLICANT_GROUP,
    options: {
      method: "POST",
      body: JSON.stringify(parameters),
    },
  }).then((response) => {
    const statusCode =
      response.statusCode === 500 ? response.statusCode : response.data ? 200 : 404;
    console.log(API_LOG_MESSAGES.CHECK_IF_SURVEY_LINKED_TO_APPLICANT_GROUP[statusCode]);
    return response.data;
  });
};

export const createApplicantSession = async (parameters) => {
  return runAPIRequest({
    request: API_REQUESTS.CREATE_APPLICANT_SESSION,
    options: {
      method: "POST",
      body: JSON.stringify(parameters),
    },
  }).then((response) => {
    console.log(API_LOG_MESSAGES.CREATE_APPLICANT_SESSION[response.statusCode]);
    switch (response.statusCode) {
      case 201:
        return true;
      case 404:
      default:
        return false;
    }
  });
};

export const checkUserAnswersStatus = async (parameters) => {
  return runAPIRequest({
    request: API_REQUESTS.CHECK_USER_ANSWERS_STATUS,
    options: {
      method: "POST",
      body: JSON.stringify(parameters),
    },
  }).then((response) => {
    const statusCode = response.statusCode === 200 ? (response.data ? 204 : 200) : 404;
    console.log(API_LOG_MESSAGES.CHECK_USER_ANSWERS_STATUS[statusCode]);

    const userCompletedSurvey = response.data;
    return userCompletedSurvey;
  });
};

export const createNonApplicantSession = async (parameters) => {
  return runAPIRequest({
    request: API_REQUESTS.CREATE_NON_APPLICANT_SESSION,
    options: {
      method: "POST",
      body: JSON.stringify(parameters),
    },
  }).then((response) => {
    console.log(API_LOG_MESSAGES.CREATE_NON_APPLICANT_SESSION[response.statusCode]);
  });
};

// Solicitud a la API remota que se ejecuta cada vez que el usuario CAMBIA DE DIMENSIÓN (únicamente en encuestas con identificador) o FINALIZA LA ENCUESTA.
export const saveAnswers = async (respondentId, respondentIdType, surveyId, answers) => {
  return runAPIRequest({
    request: API_REQUESTS.SAVE_ANSWERS,
    options: {
      method: "POST",
      body: JSON.stringify({
        answers: answers,
        survey_id: surveyId,
        identificator_type: respondentIdType,
        value: respondentId,
      }),
    },
  }).then((response) => {
    console.log(API_LOG_MESSAGES.SAVE_ANSWERS[response.statusCode]);
  });
};

// Cambia el estado de la encuesta a finalizada en la base de datos.
export const finishSurvey = async (respondentId, respondentIdType, surveyId) => {
  return runAPIRequest({
    request: API_REQUESTS.FINISH_SURVEY,
    options: {
      method: "POST",
      body: JSON.stringify({
        survey_id: surveyId,
        identificator_type: respondentIdType,
        value: respondentId,
      }),
    },
  }).then((response) => {
    console.log(API_LOG_MESSAGES.FINISH_SURVEY[response.statusCode]);
  });
};
